
import React, { useEffect, useState } from "react";
import axios from "axios";
import endPoint from "../../websitecomponents/redux/EndPoint/endpoint";

const GetReWithdrowRequest = () => {
  const [data, setData] = useState([]);
  const [summary, setSummary] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchWithdrawRequests();
  }, []);

  const fetchWithdrawRequests = async () => {
    try {
      const res = await axios.get(endPoint.getWithdrawRequestsRe, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("ResellerTokenData")}`,
        },
      });

      if (res.data.success) {
        setData(res.data.data);
        setSummary({
          totalRequests: res.data.totalRequests,
          totalRequested: res.data.totalRequested,
          totalPending: res.data.totalPending,
          totalApproved: res.data.totalApproved,
          totalRejected: res.data.totalRejected,
          totalHold: res.data.totalHold,
          totalHoldReleased: res.data.totalHoldReleased,
        });
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case "approved":
        return "bg-green-100 text-green-600";
      case "rejected":
        return "bg-red-100 text-red-600";
      default:
        return "bg-yellow-100 text-yellow-600";
    }
  };

  if (loading) return <div className="p-5 text-center">Loading...</div>;

  return (
    <div className="bg-gray-50 min-h-screen p-3 sm:p-4 md:p-6">
      {/* 🔥 SUMMARY */}
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 mb-6">
        <Card
          title="Total Requests"
          value={summary.totalRequests}
          color="text-yellow-600"
        />
        <Card
          title="Requested"
          value={`₹${summary.totalRequested}`}
          color="text-black"
        />
        <Card
          title="Pending "
          value={`₹${summary.totalPending}`}
          color="text-purple-600"
        />
        <Card
          title="Approved"
          value={`₹${summary.totalApproved}`}
          color="text-green-600"
        />
        <Card
          title="Rejected"
          value={`₹${summary.totalRejected}`}
          color="text-orange-500"
        />
        <Card
          title="Hold"
          value={`₹${summary.totalHold}`}
          color="text-blue-600"
        />
        <Card
          title="Released"
          value={`₹${summary.totalHoldReleased}`}
          color="text-red-600"
        />
      </div>

      {/* 🔥 MOBILE VIEW (CARD UI) */}
      <div className="block md:hidden space-y-4">
        {data.length === 0 ? (
          <p className="text-center text-gray-400">No requests found</p>
        ) : (
          data.map((item) => (
            <div
              key={item._id}
              className="bg-white p-4 rounded-lg shadow border"
            >
              <p>
                <strong>ID:</strong> {item.resellerCode}
              </p>
              <p>
                <strong>Amount:</strong> ₹{item.amount}
              </p>
              <p>
                <strong>Approved:</strong> ₹{item.approvedAmount || 0}
              </p>
              <p className="text-red-500">
                <strong>Hold:</strong> ₹{item.holdAmount || 0}
              </p>
              <p>
                <strong>Reason:</strong> {item.holdReason || "-"}
              </p>

              <p>
                <strong>Status:</strong>{" "}
                <span
                  className={`px-2 py-1 text-xs rounded ${getStatusColor(item.status)}`}
                >
                  {item.status}
                </span>
              </p>

              <p>
                <strong>Released:</strong> {item.holdReleased ? "Yes" : "No"}
              </p>

              <p>
                <strong>Date:</strong>{" "}
                {new Date(item.createdAt).toLocaleDateString()}
              </p>
            </div>
          ))
        )}
      </div>

      {/* 🔥 DESKTOP TABLE */}
      <div className="hidden md:block bg-white rounded-xl shadow border mt-4">
        <div className="p-4 border-b font-bold text-gray-900">
          Withdraw Requests
        </div>

        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-gray-100 text-gray-900">
              <tr>
                <th className="p-3 text-left">Reseller ID</th>
                <th className="text-center">Amount</th>
                <th className="text-center">Approved</th>
                <th className="text-center">Hold</th>
                <th className="text-center">Reason</th>
                <th className="text-center">Released</th>
                <th className="text-center">Status</th>
                <th className="text-center">Date</th>
              </tr>
            </thead>

            <tbody>
              {data.map((item) => (
                <tr key={item._id} className="border-t hover:bg-gray-50">
                  <td className="p-3">{item.resellerCode}</td>
                  <td className="text-center">₹{item.amount}</td>
                  <td className="text-center">₹{item.approvedAmount || 0}</td>
                  <td className="text-center text-red-500">
                    ₹{item.holdAmount || 0}
                  </td>
                  <td className="text-center">{item.holdReason || "-"}</td>

                  <td className="text-center">
                    {item.holdReleased ? "Released" : "Pending"}
                  </td>

                  <td className="text-center">
                    <span
                      className={`px-2 py-1 rounded text-xs ${getStatusColor(item.status)}`}
                    >
                      {item.status}
                    </span>
                  </td>

                  <td className="text-center">
                    {new Date(item.createdAt).toLocaleDateString()}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default GetReWithdrowRequest;

/* 🔥 CARD */
const Card = ({ title, value, color = "text-gray-900" }) => (
  <div className="bg-white p-4 rounded-lg shadow border">
    <p className="text-gray-700 text-sm font-semibold">{title}</p>
    <h2 className={`text-lg font-bold ${color}`}>{value || 0}</h2>
  </div>
);